export default {
    'diagram3b2-1': {
        'diagram-task': 'Q: How do you know they<br>are overconfident?',
        'diagram-hint': 'Proofs',
        'fixed-answer': 'The fundamental characteristic of entrepreneurs is not risk-taking, but overconfidence',
        'element_1_1': 'Overconfident about their ability to prevent bad outcomes',
        'element_1_2': 'Overconfident about the prospects of their businesses',
        'element_1_3': 'Overconfident about their life spans',
      'diagram-description-1': 'About ability to prevent bad outcomes',
      'diagram-description-2': 'About prospects for their businesses',
      'diagram-description-3': 'About chance of success',
      'diagram-description-4': 'About chance of failure',
      'diagram-description-5': 'About likely length of life'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b2/diagram1/i18n/en.js